module.exports = __webpack_public_path__ + "static/media/Niveau_elN3_2_345800.09c9a3e3.png";